// src/data/servicesContent.js

const servicesContent = {
    // sunglasses service content
    sunglasses: {
        heading: { heading: "Designer Sunglasses That ", headingGold: "Define Your Style" },
        collections: [
            {
                image: "/classic-elegance.png",
                title: "Luxury Classics",
                desc: " Iconic designs that never go out of style.",
            },
            {
                image: "/modern-edge.png",
                title: "Fashion Forward",
                desc: "Trendsetting frames for a modern look.",
            },
            {
                image: "/performance-series.png",
                title: "Sport and Active",
                desc: "Durable sunglasses for outdoor activities and performance.",
            },
        ],
        aboutHeroContent: {
            img: "/sunglasses-banner.jpg",
            title: "Luxury Sunglasses That Protect and Impress",
            subtitle:
                "Elevate your style while keeping your eyes safe. Discover our curated collection of designer sunglasses that combine fashion, comfort and advanced UV protection.",
        },
        VisionSectionContent: {
            title: "See Clearly, Shine Confidently",
            subtext:
                "Elite Optix offers a carefully curated collection of designer sunglasses that not only protect your eyes but also elevate your personal style. Every pair is crafted with precision to combine luxury, comfort, and the latest lens technology, ensuring you enjoy clarity and sophistication wherever you go.",
            subtexttwo: "Our sunglasses provide advanced UV protection, shielding your eyes from harmful rays while enhancing visual clarity and color perception. Whether you prefer timeless classics, modern trends, or bold statement pieces, our collection caters to every personality and lifestyle.",
            listordesc: [
                "At Elite Optix, personalized service is at the heart of everything we do. Our experts guide you in selecting frames that complement your face shape, style preferences, and daily needs. Featuring premium brands like Gucci, Ray-Ban, Oakley, Versace and more, every visit ensures your eyes are protected, your vision is precise, and your look is always unforgettable.",
            ],
            img: "/sunglasses-banner-vision.jpg"
        },
        cardContentHeading: { heading: "The Elite Optix ", headingGold: "Difference" },
        // uppersection cards content
        cardContent: [
            {
                icon: "/icons/Curated Luxury Collection.png",
                title: "Curated Luxury Collection",
                desc: "Each pair is hand-selected from world-class designers to offer eyewear that makes a statement and complements your personal style.",
            }, {
                icon: "/icons/Next-Level-Eye-Protection.png",
                title: "Next-Level Eye Protection",
                desc: "Built with advanced lens technology, our sunglasses block harmful UV rays while preserving vibrant colors and visual clarity for every environment.",
            }, {
                icon: "/icons/Tailored-Fit-and-Comfort.png",
                title: "Tailored Fit and Comfort",
                desc: "Expert guidance ensures your sunglasses perfectly match your face shape, lifestyle needs and fashion sense for unmatched confidence and comfort.",
            }],

        whyChooseContent: [
            // bottom section cards content
            { icon: "/icons/Advanced eye care using the latest technology.png", title: "Advanced eye care using the latest technology" },
            { icon: "/icons/certified-experts.png", title: "Designer frames from top luxury brands" },
            { icon: "/icons/Personalized-service-tailored-to-your-lifestyle.png", title: "Personalized service tailored to your lifestyle" },
            { icon: "/icons/Special-offers-and-promotions-to-make-premium-eyewear-accessible.png", title: "Special offers and promotions to make premium eyewear accessible" },],
    },
    // eye exam service content
    eyeExam: {
        aboutHeroContent: {
            img: "/Precision-Eye-Exams-for-Clear-Healthy-Vision.jpg",
            title: "Precision Eye Exams for Clear, Healthy Vision",
            subtitle:
                "Protect your most valuable sense with comprehensive eye exams using advanced technology and personalized care. At Elite Optix, your vision is our priority.",
        },
        VisionSectionContent: {
            title: "Expert Eye Care for Vision That Lasts",
            subtext:
                "At Elite Optix, eye exams go beyond basic checks. Using the latest diagnostic technology, we provide a detailed analysis of your vision and overall eye health to catch potential issues early and ensure your eyes stay healthy for years.",
            subtexttwo: "Every examination is tailored to your lifestyle, whether you spend long hours on screens, enjoy outdoor activities, or require specialized lenses. Our optometrists offer personalized recommendations that combine medical precision with practical solutions for your daily life.",
            subtextthree: "We believe eye care should be both thorough and comfortable. With Elite Optix, each visit is a seamless experience where clarity meets convenience, empowering you to see your world clearly, confidently and in style.",
            listordesc: [
                "From routine vision updates to comprehensive eye health evaluations, we make sure every aspect of your sight is protected. Our commitment is to provide care that not only improves vision but enhances your overall quality of life.",
            ],
            img: "/Expert-Eye-Care-for-Vision-That-Lasts.jpg"
        },
        cardContentHeading: { heading: "Precision. Protection.", headingGold: "Perfect Vision." },
        // uppersection cards content
        cardContent: [
            {
                icon: "/icons/Advanced Diagnostic Technology.png",
                title: "Advanced Diagnostic Technology",
            }, {
                icon: "/icons/Personalized Vision Solutions copy.png",
                title: "Personalized Vision Solutions",
            }, {
                icon: "/icons/Comprehensive Eye Health Care.png",
                title: "Comprehensive Eye Health Care",
            }],
        heading: { heading: "What Makes Our Eye Exams ", headingGold: "Truly Exceptional" },
        collections: [
            {
                image: "/State-of-the-Art Technology.jpg",
                title: "State-of-the-Art Technology ",
                desc: "Our advanced diagnostic equipment detects early signs of eye conditions that standard exams might miss.",
            },
            {
                image: "/Personalized-Vision-Solutions.jpg",
                title: "Personalized Vision Solutions",
                desc: "Every recommendation is customized to your lifestyle, whether for screen time, outdoor activities, or specialty lenses.",
            },
            {
                image: "/Holistic-Eye-Health-Care.jpg",
                title: "Holistic Eye Health Care",
                desc: "We assess not just your vision but overall eye wellness, providing guidance to maintain healthy eyes for years to come.",
            },
        ],

        whyChooseContent: [
            // bottom section cards content
            { icon: "/icons/Expert Optometrists.png", title: "Expert Optometrists" },
            { icon: "/icons/Early Detection and Prevention.png", title: "Early Detection and Prevention" },
            { icon: "/icons/Comprehensive Lens Recommendations.png", title: "Comprehensive Lens Recommendations" },
            { icon: "/icons/Trusted by the Community.png", title: "Trusted by the Community" },],
    },
    // safety glasses service content
    safetyGlasses: {
        aboutHeroContent: {
            img: "/Protect-Your-Eyes-in-Style-and-Comfort.jpg",
            title: "Protect Your Eyes in Style and Comfort",
            subtitle:
                "Elite Optix provides high-quality prescription protective eyewear designed for clarity, comfort, and reliable protection. All our safety glasses meet international ANSI Z87.1 and CSA Z94.3 standards, ensuring trusted performance in any work environment.\n\nWe offer a wide selection of designs and colors, so you can feel safe and comfortable while still looking stylish. Choose from a range of frame options, including wrap around frames for maximum coverage, side shields, and more to match your needs and your look."


        },
        VisionSectionContent: {
            title: "Ultimate Protection Meets Modern Design",
            subtext:
                "At Elite Optix, safety does not mean sacrificing style. Our safety glasses are engineered to provide superior protection for your eyes while offering sleek, contemporary designs that you can wear confidently every day.",
            subtexttwo: "Each pair is crafted with durable, high-quality materials to withstand impact, dust, and debris, making them ideal for workplaces, sports, or any high-risk environment. Advanced lens technology ensures clear vision without distortion, so safety and performance go hand in hand.",
            subtextthree: "Our experts help you select the right frames and lenses based on your activities and lifestyle, ensuring maximum comfort and fit. With Elite Optix safety glasses, you get peace of mind knowing your eyes are fully protected while looking sharp and stylish.",
            listordesc: [
                "Designed for both professionals and enthusiasts, our safety glasses meet strict safety standards while offering modern aesthetics. Every detail is focused on providing durability, comfort, and confidence for all your eye protection needs.",
            ],
            img: "/Ultimate Protection Meets Modern Design.jpg"
        },
        cardContentHeading: { heading: "Why Elite Optix Safety Glasses ", headingGold: "Stand Out" },
        // uppersection cards content
        cardContent: [
            {
                icon: "/icons/sunglasses-card-2.png",
                title: "Certified Eye Protection",
            }, {
                icon: "/icons/sunglasses-card-1.png",
                title: "Durable and Stylish Designs",
            }, {
                icon: "/icons/sunglasses-card-3.png",
                title: "Custom Fit and Comfort",
            }],
        heading: { heading: "Key Benefits of Our ", headingGold: "Safety Glasses" },
        collections: [
            {
                image: "/Impact-Resistant-Lenses.jpg",
                title: "Impact-Resistant Lenses",
                desc: " Strong lenses that protect your eyes from flying debris and accidental impacts.",
            },
            {
                image: "/Lightweight-and-Comfortable.jpg",
                title: "Lightweight and Comfortable ",
                desc: "Ergonomic frames designed for all-day wear without discomfort.",
            },
            {
                image: "/Stylish-Designs.jpg",
                title: "Stylish Designs ",
                desc: "Modern, sleek eyewear that keeps you looking confident while staying safe.",
            },
        ],
        whyChooseContent: [
            // bottom section cards content
            { icon: "/icons/Advanced Safety Standards.png", title: "Advanced Safety Standards" },
            { icon: "/icons/Innovative Lens Technology.png", title: "Innovative Lens Technology" },
            { icon: "/icons/Certified Protection.png", title: "Certified Protection" },
            { icon: "/icons/Durable Materials.png", title: "Durable Materials" },],
    },
    // eye glasses service content
    eyeGlasses: {
        aboutHeroContent: {
            img: "/eye-glasses-banner.jpg",
            title: "Designer Eyewear That Defines Your Style",
            subtitle:
                "Explore our curated collection of premium eyeglasses that combine flawless vision, ultimate comfort, and modern style. See clearly while making a statement with every look.",
        },
        VisionSectionContent: {
            title: "Eyewear That Reflects Your Style and Vision",
            subtext:
                "At Elite Optix, eyewear is more than just a tool for vision. It is a reflection of your personality and style. Our designer eyeglasses are carefully selected to combine elegance, comfort and precise vision correction, giving you confidence in every look.",
            subtexttwo: "Each pair features high-quality materials and advanced lens technology, ensuring durability and clarity for daily wear. Whether you prefer timeless classics, contemporary designs or bold statement frames, our collection caters to every taste and lifestyle.",
            subtextthree: "Our experts guide you in choosing frames that perfectly suit your face shape, prescription needs and personal style. With brands like Gucci, Ray-Ban, Versace and Oakley, Elite Optix ensures that every visit leaves you seeing clearly and looking your best.",
            listordesc: [
                "Designed for every lifestyle and occasion, our eyewear balances fashion with function. Every detail is focused on comfort, precision and a luxurious experience that enhances your everyday life.",
            ], img: "/eye-glasses-vision.jpg"
        },
        cardContentHeading: { heading: "See Clearly, Look ", headingGold: "Exceptionally" },
        cardContent: [{
            icon: "/icons/Designer Frame Collection.png",
            title: "Designer Frame Collection",
        }, {
            icon: "/icons/Precision Vision Technology.png",
            title: "Precision Vision Technology",
        }, {
            icon: "/icons/Personalized-Fit-and-Comfort.png",
            title: "Personalized Fit and Comfort",
        }],
        heading: { heading: "Key Benefits of Elite Optix", headingGold: "Eyeglasses" },
        collections: [
            {
                image: "/Premium-Designer-Frames.jpg",
                title: "Premium Designer Frames ",
                desc: " Hand-selected brands that elevate your style and complement your personality",
            },
            {
                image: "/Advanced-Lens-Technology.jpg",
                title: "Advanced Lens Technology",
                desc: "Lenses designed for precise vision, durability, and all-day comfort",
            },
            {
                image: "/Customized-Fit-and-Comfort.jpg",
                title: "Customized Fit and Comfort ",
                desc: "Expert adjustments ensure frames suit your face shape and lifestyle perfectly",
            },
        ],
        whyChooseContentHeading: { heading: "Why Elite Optix ", headingGold: "Eyeglasses" },
        whyChooseContent: [
            // bottom section cards content
            { icon: "/icons/luxury-experience.png", title: "Luxury Designer frames that make a statement" },
            { icon: "/icons/Clarity-Advanced-lenses-for-perfect-vision.png", title: "Clarity Advanced lenses for perfect vision" },
            { icon: "/icons/Comfort Lightweight fit for all-day wear.png", title: "Comfort Lightweight fit for all-day wear" },
            { icon: "/icons/Style Frames that match your personality.png", title: "Style Frames that match your personality" },],
    },
    // sports goggles service content
    sportsGoggles: {
        aboutHeroContent: {
            img: "/Performance-and-Protection-for-Every-Sport.jpg",
            title: "Performance and Protection for Every Sport",
            subtitle:
                "Elite Optix sports goggles combine advanced eye protection with comfort and style. Stay focused, safe, and perform at your best in any activity.",
        },
        VisionSectionContent: {
            title: "Protect Your Eyes. Enhance Your Game.",
            subtext:
                "Elite Optix offers high-quality sport goggles suitable for a wide range of activities, including basketball, tennis, soccer, swimming, and water sports.",
            subtexttwo: "Advantages:",
            listordesc: [
                "Designed for maximum comfort and durability",
                "Stay securely in place during intense activities",
                "Available with prescription lenses",
                "Customizable to match team colors or jerseys",
                "Offered at affordable prices"
            ],
            img: "/Protect-Your-Eyes-Enhance-Your-Game.jpg"
        },
        cardContentHeading: { heading: "Sports Goggles That Keep You  ", headingGold: "Ahead" },
        // uppersection cards content
        cardContent: [
            {
                icon: "/icons/Impact-Resistant Protection.png",
                title: "Impact-Resistant Protection",
            }, {
                icon: "/icons/Enhanced Visual Performance.png",
                title: "Enhanced Visual Performance",
            }, {
                icon: "/icons/Secure and Comfortable Fit.png",
                title: "Secure and Comfortable Fit",
            }],
        heading: { heading: "Why Athletes Trust Elite Optix  ", headingGold: "Eyeglasses" },
        collections: [
            {
                image: "/Maximum-Impact-Resistance.jpg",
                title: "Maximum Impact Resistance",
                desc: " Tested and built to handle high-velocity impacts and rough conditions without compromising safety",
            },
            {
                image: "/Performance-Enhancing-Lenses.jpg",
                title: "Performance-Enhancing Lenses",
                desc: "Specialized lens technology boosts contrast, reduces glare, and sharpens vision for peak performance.",
            },
            {
                image: "/Custom-Fit-for-Every-Athlete.jpg",
                title: "Custom Fit for Every Athlete",
                desc: "Adjustable and ergonomic designs ensure a secure, comfortable fit no matter the intensity or duration of your activity.",
            },
        ],
        whyChooseContentHeading: { heading: "Why Choose Elite Optix ", headingGold: "Sports Goggles" },
        whyChooseContent: [
            // bottom section cards content
            { icon: "/icons/Impact-Resistant.png", title: "Impact-Resistant" },
            { icon: "/icons/Vision-Enhancing.png", title: "Vision-Enhancing" },
            { icon: "/icons/Ergonomic.png", title: "Ergonomic" },
            { icon: "/icons/Athlete-Approved.png", title: "Athlete-Approved" },],
    },
    // contact lenses service content
    contactLenses: {
        aboutHeroContent: {
            img: "/contact-lenses-banner.jpg",
            title: "Comfortable Vision, Clear and Effortless",
            subtitle:
            "At Elite Optix, we offer a wide range of contact lens brands, including Acuvue, Alcon, Bausch + Lomb, and CooperVision.",
        },
        VisionSectionContent: {
            title: "Freedom to See Clearly, All Day",
            subtext: "Elite Optix contact lenses combine precision, comfort, and convenience. Enjoy all-day clarity without compromising style or eye health.",
            subtexttwo: "Our wide selection includes lenses for every prescription, lifestyle, and preference, from daily disposables to specialty lenses. Advanced materials ensure breathability, moisture retention, and all-day comfort, keeping your eyes healthy and refreshed.",
            subtextthree: "Our expert optometrists and opticians can guide you through proper lens hygiene and wear, including:",
            listordesc: [
                "Preparing the lens for use",
                "Handling the lenses safely",
                "Placing the lens on the eye",
                "Centering the lens for optimal comfort",
                "Removing the lens correctly",
            ], img: "/eye-health-protection.jpg"
        },
        cardContentHeading: { heading: "Advanced Technology for Superior ", headingGold: "Vision and Comfort" },
        // uppersection cards content
        cardContent: [
            {
                icon: "/icons/Advanced-UV-Protection.png",
                title: "Advanced UV Protection",
            }, {
                icon: "/icons/All-Day-Comfort.png",
                title: "All-Day Comfort",
            }, {
                icon: "/icons/Customized-Fit.png",
                title: "Customized Fit",
            }],
        heading: { heading: "Experience the Elite Difference in Contact Lenses ", headingGold: "Contact Lenses" },
        collections: [
            {
                image: "/contact-lenses-vision.jpg",
                title: "Multifocal (Spherical and Toric)",
                desc: "Designed to provide excellent visual acuity for individuals over 40, these lenses offer clear vision at all distances. They enable a seamless transition from near to far, allowing you to enjoy extended screen time with effortless clarity.",
            },
            {
                image: "/All-Day Comfort.jpg",
                title: "Spherical and Astigmatism ",
                desc: "They offer the flexibility you need—whether you&#39;re at work, in school, at social events, or participating in sports activities.",
            },
            {
                image: "/Precision Vision.jpg",
                title: "Optimal combination of natural moisture and breathability",
                desc: " Retains 96% of its moisture for up to 16 hours with no additives",
            },
        ],
        whyChooseContentHeading: { heading: "Key Advantages of Elite", headingGold: "Contact Lenses" },
        whyChooseContent: [
            // bottom section cards content
            { icon: "/icons/Moisture-Retentive.png", title: "Moisture-Retentive" },
            { icon: "/icons/Anti-Reflective.png", title: "Anti-Reflective" },
            { icon: "/icons/UV-Blocking.png", title: "UV-Blocking" },
            { icon: "/icons/High-Definition-Optics.png", title: "High-Definition Optics" },],
    },
};

export default servicesContent;
